import {Routes} from '@angular/router';
import {
  ContactDataUpdateApplicantSectionComponent
} from './sections/contact-data-update-applicant-section/contact-data-update-applicant-section.component';
import {
  CurrentResidentialAddressSectionComponent
} from './sections/current-residential-address-section/current-residential-address-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  CurrentDeliveryAddressSectionComponent
} from './sections/current-delivery-address-section/current-delivery-address-section.component';
import {
  ContactDataUpdateOtherDataSectionComponent
} from './sections/contact-data-update-other-data-section/contact-data-update-other-data-section.component';
import {SessionService} from '../../../../services/ssession.service';

export const desktopStages: string[] = [
  'Dane identyfikacyjne',
  'Aktualny adres zamieszkania',
  'Aktualny adres do doręczeń',
  'Inne dane',
  'Zgody',
  'Załączniki'
];

export const mobileStages: string[] = [
  'Dane identyfikacyjne',
  'Aktualny adres zamieszkania',
  'Aktualny adres do doręczeń',
  'Inne dane',
  'Zgody',
  'Załączniki'
];

export const stages: string[] = SessionService.GetUISettings()?.mobileEmbed ? mobileStages : desktopStages;

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../inne-dane',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const contactDataUpdateDesktopRoutes: Routes = [
  {
    path: 'dane-identyfikacyjne',
    component: ContactDataUpdateApplicantSectionComponent
  },
  {
    path: ':appId/dane-identyfikacyjne',
    component: ContactDataUpdateApplicantSectionComponent
  },
  {
    path: ':appId/adres-zamieszkania',
    component: CurrentResidentialAddressSectionComponent
  },
  {
    path: ':appId/adres-do-doreczen',
    component: CurrentDeliveryAddressSectionComponent
  },
  {
    path: ':appId/inne-dane',
    component: ContactDataUpdateOtherDataSectionComponent,
    data: {
      successUrl: '../zgody'
    }
  },
  {
    path: ':appId/zgody',
    component: AgreementsDataSectionComponent,
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  {
    path: '',
    redirectTo: 'dane-identyfikacyjne',
    pathMatch: 'prefix'
  },
  // 1 steep fix
  {
    path: ':appId/informacje-podstawowe',
    redirectTo: ':appId/dane-identyfikacyjne',
    pathMatch: 'prefix'
  }
];

export const contactDataUpdateMobileRoutes: Routes = [
  {
    path: 'dane-identyfikacyjne',
    component: ContactDataUpdateApplicantSectionComponent
  },
  {
    path: ':appId/dane-identyfikacyjne',
    component: ContactDataUpdateApplicantSectionComponent
  },
  {
    path: ':appId/adres-zamieszkania',
    component: CurrentResidentialAddressSectionComponent
  },
  {
    path: ':appId/adres-do-doreczen',
    component: CurrentDeliveryAddressSectionComponent
  },
  {
    path: ':appId/inne-dane',
    component: ContactDataUpdateOtherDataSectionComponent,
    data: {
      successUrl: '../zgody'
    }
  },
  {
    path: ':appId/zgody',
    component: AgreementsDataSectionComponent,
    data: {
      ...agreementsDataSectionConfig,
      removeRegulationsControl: true
    }
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: {
      ...attachmentDataSectionConfig,
      cancelUrl: '../zgody'
    }
  },
  {
    path: '',
    redirectTo: 'dane-identyfikacyjne',
    pathMatch: 'prefix'
  },
  // 1 steep fix
  {
    path: ':appId/informacje-podstawowe',
    redirectTo: ':appId/dane-identyfikacyjne',
    pathMatch: 'prefix'
  }
];

export const contactDataUpdateRoutes: Routes = SessionService.GetUISettings()?.mobileEmbed ? contactDataUpdateMobileRoutes : contactDataUpdateDesktopRoutes;
